import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import { Components } from './multiSelect.style';
export const selectAllOption = {
  id: 'selectAll',
  label: 'Select All',
  value: 'selectAll'
};
export const deSelectAllOption = {
  label: 'Deselect All',
  value: 'deselectAll'
};
export const checkIsAllSelected = newValue => !!newValue.filter(item => item.value === 'selectAll').length;
export const checkIsAllDeselected = newValue => !!newValue.filter(item => item.value === 'deselectAll').length;
export const modifyMultiSelectValue = (newValue, localOptions, isAllSelected, isAllDeselected) => {
  if (isAllSelected) {
    const allOptions = localOptions.filter(item => item.value !== 'selectAll');
    return getAllOptions(allOptions);
  }
  if (isAllDeselected) {
    return [];
  }
  return newValue.filter(item => !item.isDisabled);
};
/**
 *  Returs CSS for variant equals default.
 */
export const heighLighter = {
  option: (provided, state) => Components.CustomStyles.HeighLighterUtil(provided, state),
  multiValue: provided => Components.CustomStyles.MultiValue(provided),
  multiValueRemove: provided => Components.CustomStyles.MultiValueRemove(provided),
  groupHeading: provided => Components.CustomStyles.GroupHeading(provided)
};
/**
 *  Returs CSS for variant except default.
 */
export const noHeighLighter = {
  option: provided => Components.CustomStyles.NoHeighLighterUtil(provided),
  multiValue: provided => Components.CustomStyles.MultiValue(provided),
  multiValueRemove: provided => Components.CustomStyles.MultiValueRemove(provided),
  groupHeading: provided => Components.CustomStyles.GroupHeading(provided)
};
export const checkIfSubOptionsChecked = (optionsObj, optionSelected) => {
  let allChecked = true;
  let anyChecked = false;
  const optionSelectedValues = optionSelected.map(item => item.value);
  const checkInNested = optionsArr => {
    for (let index = 0; index < optionsArr.length; index++) {
      if (optionsArr[index].options) {
        checkInNested(optionsArr[index].options);
      } else if (!optionSelectedValues.includes(optionsArr[index].value)) {
        allChecked = allChecked ? false : allChecked;
      } else if (optionSelectedValues.includes(optionsArr[index].value)) {
        anyChecked = !anyChecked ? true : anyChecked;
      }
    }
  };
  if (optionSelected.map(item => item.value).includes(optionsObj.value)) {
    return {
      allChecked: true,
      anyChecked: true
    };
  } else {
    if (!optionsObj.options) {
      return {
        allChecked: false,
        anyChecked: false
      };
    } else {
      checkInNested(optionsObj.options);
    }
  }
  return {
    allChecked,
    anyChecked
  };
};
export const getAllOptions = function (allOptions) {
  let allowDisabled = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  const result = [];
  const getAllOptionsRec = options => {
    options.forEach(item => {
      if (item.options) {
        getAllOptionsRec(item.options);
      } else {
        if (allowDisabled) {
          result.push(item);
        } else {
          !item.isDisabled && result.push(item);
        }
      }
    });
  };
  getAllOptionsRec(allOptions);
  return result;
};
export const getAllGroupHeadingIds = allOptions => {
  const result = [];
  const getAllOptionsRec = options => {
    options.forEach(item => {
      if (item.options || item.hasChildren) {
        result.push(item.value);
        getAllOptionsRec(item.options || []);
      }
    });
  };
  getAllOptionsRec(allOptions);
  return result;
};
export const modifyOptionsWithDisabled = allOptions => {
  const getAllOptionsRec = (options, isGroupDisabled) => {
    options.forEach(item => {
      if (item.options) {
        const isGroupOptionDisabled = item.isDisabled || isGroupDisabled;
        if (isGroupOptionDisabled) {
          item.isDisabled = isGroupOptionDisabled;
        }
        getAllOptionsRec(item.options, isGroupOptionDisabled);
      } else {
        if (item.isDisabled || isGroupDisabled) {
          item.isDisabled = item.isDisabled || isGroupDisabled;
        }
      }
    });
  };
  getAllOptionsRec(allOptions, false);
  return allOptions;
};
export const modifySelectedValues = (localOptions, value) => {
  const values = value.map(item => item.value);
  const result = [];
  const modifySelectedValuesRec = options => {
    options.forEach(item => {
      if (item.options) {
        if (values.includes(item.value)) {
          result.push.apply(result, _toConsumableArray(getAllOptions(item.options, true)));
        }
        modifySelectedValuesRec(item.options);
      } else {
        if (values.includes(item.value)) {
          result.push(item);
        }
      }
    });
  };
  if (!values.length) {
    return result;
  }
  modifySelectedValuesRec(localOptions);
  return result;
};
export const modifySelectionWithGroupHeading = (options, value) => {
  const result = [];
  const values = value.map(item => item.value);
  const rec = data => {
    for (let i = 0; i < data.length; i++) {
      if (data[i].options) {
        const {
          allChecked
        } = checkIfSubOptionsChecked(data[i], value);
        if (allChecked) {
          const {
            id,
            label,
            value
          } = data[i];
          result.push({
            id,
            label,
            value
          });
          continue;
        } else {
          rec(data[i].options);
        }
      } else {
        if (values.includes(data[i].value)) {
          result.push(data[i]);
        }
      }
    }
  };
  rec(options);
  return result;
};